"use strict";
/**
 * @class TooltipForCopy
 * @description Component for displaying a truncated (by default) field the user can click to
 * pop up a tooltip with full text, as well as copy it to the clipboard.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../codegen/Messages");
var Clipboard_1 = require("./Clipboard");
var index_1 = require("../index");
var util_1 = require("../utils/util");
require("../utils/polyfill");
var TooltipForCopy = function (_a) {
    var charactersToShow = _a.charactersToShow, fullText = _a.fullText, testId = _a.testId, rest = __rest(_a, ["charactersToShow", "fullText", "testId"]);
    var shortText = util_1.truncate(fullText, charactersToShow);
    var close = function (event) {
        var container = event.currentTarget.closest("[oui-dropdown]") ||
            event.currentTarget.closest("[data-oui-dropdown]");
        container && global.ouiUIkit.dropdown(container).hide(false);
    };
    return (React.createElement("span", __assign({}, rest),
        React.createElement(index_1.Button, { type: index_1.ButtonType.Button, buttonStyle: index_1.ButtonStyle.MutedLink }, shortText),
        React.createElement(index_1.Tooltip, { testId: testId },
            fullText,
            React.createElement("div", { className: "oui-flex oui-flex-between" },
                React.createElement(Clipboard_1.ClipboardLink, { text: fullText }),
                React.createElement(index_1.Button, { type: index_1.ButtonType.Button, buttonStyle: index_1.ButtonStyle.MutedLink, onClick: close }, Messages.Common.close())))));
};
exports.default = TooltipForCopy;
//# sourceMappingURL=TooltipForCopy.js.map